import { SET_TICKETS_URI } from "@/store/mutationTypes";
import { tickets } from "../../api";
import { SET_MEMBERSHIP_SCAN_PENDING } from "../mutationTypes";

export default {
  actions: {
    setTicketsUri({ commit }, uri) {
      commit(SET_TICKETS_URI, uri);
    },
    async checkTicket({ commit }, {code, time}) {
      return await tickets.checkTicket(code, time);
    },

    recordMembershipScan({commit}) {
      commit(SET_MEMBERSHIP_SCAN_PENDING, true)
    },

    membershipScanRecorded({commit}) {
      commit(SET_MEMBERSHIP_SCAN_PENDING, false)
    }
  },
};
